import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastProvider } from '@contexts/Toast';
import { ConfirmationToastProvider } from '@contexts/ConfirmationToast';
import { WarningToastProvider } from '@contexts/WarningToast';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ToastProvider>
      <ConfirmationToastProvider>
        <WarningToastProvider>
          <App />
        </WarningToastProvider>
      </ConfirmationToastProvider>
    </ToastProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
